export type OpsPermissions = {
  overview:      boolean
  activity:      boolean
  orders_sendto: boolean
  orders_upload: boolean
  orders_requests: boolean
  ops_outbound:  boolean
  ops_receive:   boolean
  ops_complete:  boolean
  ops_tickets:   boolean
  ops_incoming:  boolean
  inv_overview:  boolean
  inv_today:     boolean
  inv_fifo:      boolean
  inv_picking:   boolean
  inv_shortage:  boolean
  inv_reserved:  boolean
  inv_stock:     boolean
  inv_movements: boolean
  inv_adjust:    boolean
}

export const OPS_PERMISSIONS_NONE: OpsPermissions = {
  overview: false, activity: false,
  orders_sendto: false, orders_upload: false, orders_requests: false,
  ops_outbound: false, ops_receive: false, ops_complete: false, ops_tickets: false, ops_incoming: false,
  inv_overview: false, inv_today: false, inv_fifo: false, inv_picking: false, inv_shortage: false,
  inv_reserved: false, inv_stock: false, inv_movements: false, inv_adjust: false,
}

export function hasAnyOrdsPerm(p: OpsPermissions): boolean {
  return p.orders_sendto || p.orders_upload
}
export function hasAnyOpsPerm(p: OpsPermissions): boolean {
  return p.ops_outbound || p.ops_receive || p.ops_complete || p.ops_tickets || p.ops_incoming
}
export function hasAnyInvPerm(p: OpsPermissions): boolean {
  return p.inv_overview || p.inv_today || p.inv_fifo || p.inv_picking ||
         p.inv_shortage || p.inv_reserved || p.inv_stock || p.inv_movements || p.inv_adjust
}
export function countPerms(p: OpsPermissions): number {
  return (Object.values(p) as boolean[]).filter(Boolean).length
}
export const TOTAL_PERMS = 18
